import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useStockAdjustmentReasons() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarMotivosAjusteStock.php", {
      token: userData.token,
    });
    setList(response.map((e) => ({ id: e.id, text: e.descripcion })));
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
